<template>

    <div class="panel-wrapper">

        <!-- HEADER -->
        <div class="header" :style="{ backgroundColor: cssPropColor('$color-primary') }">
            <span class="icon">
                <label @click="closePanel($event)" for="panel-toggle" title="Close"><i class="icon-MBR_close" aria-hidden="true"></i></label>
            </span>
            <span class="label" v-html="content.exposure_label"></span>
        </div>
        <!-- END HEADER -->

        <!-- CONTENT -->
        <div class="panel-content" data-simplebar>

            <!-- ICONIC -->
            <div class="iconic" v-if="content.media.sources[0]">
                <img :src="content.media.sources[0]" />
            </div>
            <!-- END ICONIC -->

            <!-- BODY -->
            <div class="body">
                <div class="inner">

                    <div class="intro" v-html="content.lead_in"></div>

                    <hr />

                    <section v-if="content.loss_example">
                        <h3 :style="{ color: cssPropColor('$color-primary') }">Loss Example</h3>
                        <div v-html="content.loss_example"></div>
                        <hr v-if="content.maintenance_tip"  />
                    </section>

                    <section v-if="content.maintenance_tip">
                        <h3 :style="{ color: cssPropColor('$color-primary') }">Maintenance Tip</h3>
                        <div v-html="content.maintenance_tip"></div>
                        <hr />
                    </section>

                    <div class="disclaimer" v-html="disclaimer"></div>

                    <div class="return-home align-center justify-center">
                        <button type="button" class="btn" @click="backToHome" :style="{ backgroundColor: cssPropColor('$color-secondary') }">Back to Home</button>
                    </div>

                </div>
            </div>
            <!-- END BODY -->

        </div>
        <!-- END CONTENT -->

    </div>

</template>


<script>

    let vm = {};

    export default {

        name: 'panel-content-about',

        props: ['title', 'panel'],

        components: {},

        data() {
            return {

            }
        },

        computed: {

            content() {
                return this.$dataStore.getters.getPowerSurgeData;
            },

            disclaimer() {
                return this.$dataStore.getters.getExposureDisclaimer;
            }

        },

        created() {
            //console.info('%csidebar-content-privacy::created', 'color:dodgerblue;');
        },

        mounted() {
            //console.info('%csidebar-content-privacy::mounted', 'color:green;');

            vm = this;
        },

        methods: {

            isLast(idx) {
                return idx === this.content.exposure.sections.length - 1;
            },

            backToHome() {
                //console.info('backToHome');
                this.$dataStore.dispatch('POWER_SURGE_OVERLAY', { val: false });
                this.$dataStore.dispatch('POWER_SURGE', { val: false });
                this.$dataStore.dispatch('POWER_SURGE_STATE', { val: false });
                this.$eventBus.$emit('power-surge:end');
                this.$dataStore.dispatch('PANEL_OPEN', { val: false });
                this.$dataStore.dispatch('ACTIVE_PANEL', { val: null });
                // show points
                this.$eventBus.$emit('points:show');
            },

            closePanel(evt){
                vm.$eventBus.$emit('residence:zoomout');
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        },

        events: {

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .panel-wrapper {
        height: 100%;
        position: relative;
        animation-duration: 0s;
        animation-delay: 0.6s;
    }

    .panel-content {

        & .disclaimer {
            font-family: $font-univers-std;
            font-size: 0.688rem;
            font-weight: normal;
            line-height: 1.375;
            letter-spacing: 0;
            text-align: left;
            padding: 0 0 0 0;
        }
    }

    .iconic {
        margin: 0 0 0 0;

        & > img {
            max-width: 100%;
            height: auto;
        }

        & .icon {

            & > i {
                font-size: 4.375rem;
                color: var(--color-secondary);
            }
        }
    }

    .return-home {
        margin: 30px 0 0 0;
    }

</style>

<style lang="scss">
    .btn {
        background-color: var(--color-secondary);
    }
</style>


// WEBPACK FOOTER //
// PanelContentPowerSurge.vue?06eff2d5